export default String.raw`
.blog-post {

    &__main {
        flex-direction: column;
        padding: 0 16px 24px 16px;
    }
    
    &__article {
        width: 100%;
    }

    &__sidebar {
        width: 100%;
        padding: 0;
        gap: 0;
    }

    &__all-articles {
        margin-left: auto;
        @include h4-headline;
    }
}

.article {
    &__header {
        h1 {
            @include h3-headline;
        }
    }

    &__metadata {
        flex-direction: column;
        gap: 8px;
    
        &-time {
            display: flex;
            justify-content: space-between;
    
            .blog-item__read-time {
                display: block;
            }
        }
    }

    &__footer {
        flex-direction: column;

        &-share {
            width: 100%;
            padding: 0px 16px;
        }
    }
}

.sidebar {
    &__header {
        padding-left: 0;
        padding-right: 0;
        @include h3-headline;
    }

    .blog-post__all-articles {
        display: none;
    }

    &__next-article,
    &__latests-posts {
        border: none;
    }

    .blog-item {
        padding: 0;
    }

    &__latests-posts {
        .blog-item {
            padding: 0;

            &__wrapper {
                gap: 16px;
            }

            &__title {
                display: block;
                @include h3-headline;
                white-space: nowrap;
            }

            &__content {
                display: block;
                height: 3lh;
                -webkit-line-clamp: 3;
                @include body-1-regular;
                margin-bottom: 8px;
            }

            &__read {
                display: flex;
            }
        }

        .swiper {
            display: flex;
            width: 100%;
        }

        .swiper-slide {
            width: 75%;
        }

        .swiper-wrapper {
            flex-direction: row;
        }
    }
}
`